(() => {
  const current = document.currentScript;
  if (!current) return;
  const asset = (name) => {
    const url = new URL(current.src);
    url.search = '';
    url.pathname = url.pathname.replace(/labaykanusuk-play\.js$/, name);
    return url.toString();
  };
  const core = document.createElement('script');
  core.src = asset('labaykanusuk-play-core.js');
  core.onload = () => {
    const modes = document.createElement('script');
    modes.src = asset('labaykanusuk-play-modes.js');
    modes.onload = () => {
      const articleVideos = document.createElement('script');
      articleVideos.src = asset('labaykanusuk-play-article-videos.js');
      document.head.appendChild(articleVideos);
    };
    document.head.appendChild(modes);
  };
  document.head.appendChild(core);
})();